// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Payment methods + auto-topup + top-up dialog
   Imported by BillingPage. Brand-cohesive with the rest of the app
   (gradient: #FF6B4A → #E94B6C → #8E3A9A). */

/* ─── TopUp Dialog ─────────────────────────────────────────── */

.topup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 15, 20, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: tuFadeIn 180ms ease;
}
@keyframes tuFadeIn { from { opacity: 0; } to { opacity: 1; } }

.topup-dialog {
  background: #fff;
  border-radius: 16px;
  width: min(440px, 92vw);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  animation: tuSlideIn 240ms cubic-bezier(0.2, 0.7, 0.2, 1);
}
@keyframes tuSlideIn {
  from { transform: translateY(12px) scale(0.985); opacity: 0; }
  to   { transform: translateY(0) scale(1); opacity: 1; }
}

.topup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #ECEDF2;
  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);
}
.topup-header h3 { margin: 0; font-size: 18px; font-weight: 700; }
.topup-close {
  border: none; background: transparent; cursor: pointer;
  font-size: 24px; line-height: 1; color: #6c757d; padding: 0 6px;
  border-radius: 6px;
}
.topup-close:hover { background: rgba(0,0,0,0.05); color: #1a1a1a; }

.topup-body { padding: 22px; display: flex; flex-direction: column; gap: 16px; }

.topup-method-tabs {
  display: flex; gap: 0;
  border-bottom: 1px solid #ECEDF2;
  padding: 0 22px;
}
.topup-method-tab {
  flex: 1 1;
  background: transparent;
  border: none;
  padding: 12px 16px;
  font-size: 14px; font-weight: 600; color: var(--text-secondary);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s;
}
.topup-method-tab:hover { color: var(--text-primary); }
.topup-method-tab.active {
  color: #E94B6C;
  border-bottom-color: #E94B6C;
}

.bank-detail {
  display: flex; flex-direction: column; gap: 4px;
  padding: 10px 14px;
  background: #F7F8FB;
  border-radius: 10px;
}
.bank-detail-highlight {
  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);
  border: 1px solid rgba(233, 75, 108, 0.3);
}
.bank-detail-label {
  font-size: 11px; font-weight: 600; color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.4px;
}
.bank-detail-value {
  font-size: 14px; color: var(--text-primary);
  display: flex; align-items: center; gap: 8px;
  word-break: break-all;
}
.bank-detail-value.mono {
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 13px;
}
.bank-detail-copy {
  background: #fff;
  border: 1px solid #ECEDF2;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px; font-weight: 600; color: var(--text-secondary);
  cursor: pointer;
  margin-left: auto;
  flex-shrink: 0;
}
.bank-detail-copy:hover { background: #F7F8FB; color: var(--text-primary); }
.bank-detail-copy:active { background: #ECEDF2; }

.topup-presets { display: flex; gap: 8px; }
.topup-preset {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
  border: 1px solid #ECEDF2;
  background: #fff;
  border-radius: 10px;
  padding: 10px 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: #6c757d;
  transition: all 0.15s;
}
.topup-preset:hover { border-color: #E94B6C; color: #1a1a1a; }
.topup-preset.active {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);
  color: #fff;
  border-color: transparent;
}

.topup-amount-label {
  display: flex; flex-direction: column; gap: 6px;
  font-size: 13px; font-weight: 600; color: #6c757d;
}
.topup-amount-label input {
  padding: 12px 14px;
  border: 1px solid #ECEDF2;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 600;
  font-family: inherit;
  outline: none;
}
.topup-amount-label input:focus { border-color: #E94B6C; }

/* FX preview shown under the amount field when the card charge currency
   differs from the balance currency. */
.topup-fx-preview {
  padding: 10px 12px;
  background: linear-gradient(180deg, rgba(233, 75, 108, 0.06) 0%, rgba(142, 58, 154, 0.04) 100%);
  border: 1px solid rgba(233, 75, 108, 0.18);
  border-radius: 10px;
  display: flex; flex-direction: column; gap: 4px;
}
.topup-fx-preview.loading { color: #6c757d; font-size: 12px; font-style: italic; }
.topup-fx-preview.error {
  background: #fde8e8; border-color: #f5cdd2; color: #c1392b;
  font-size: 12px;
}
.topup-fx-row {
  display: flex; align-items: baseline; gap: 8px;
  flex-wrap: wrap;
}
.topup-fx-arrow {
  font-size: 16px; font-weight: 700;
  color: #E94B6C;
}
.topup-fx-amount {
  font-size: 17px; font-weight: 700; color: #1a1d29;
  font-variant-numeric: tabular-nums;
}
.topup-fx-meta {
  font-size: 12px; color: #6c757d;
}
.topup-fx-rate {
  font-size: 11px; color: #6c757d;
  font-variant-numeric: tabular-nums;
}

.topup-save-toggle {
  display: flex; align-items: center; gap: 10px;
  font-size: 14px; cursor: pointer;
  padding: 10px 12px;
  border-radius: 8px;
  background: #F7F8FB;
}
.topup-save-toggle input { width: 18px; height: 18px; cursor: pointer; }

/* ─── Saved-card picker inside Top up dialog ─────────────────── */
.topup-cards { display: flex; flex-direction: column; gap: 8px; }
.topup-cards-label {
  font-size: 12px; font-weight: 600; color: #6c757d;
  text-transform: uppercase; letter-spacing: 0.4px;
  margin-bottom: 2px;
}
.topup-card-option {
  display: flex; align-items: center; gap: 12px;
  padding: 11px 14px;
  border: 1px solid #ECEDF2;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}
.topup-card-option:hover:not(.disabled) { border-color: #d8d9e1; }
.topup-card-option.selected {
  border-color: rgba(233, 75, 108, 0.55);
  background: linear-gradient(180deg, #fff 0%, #fff7f5 100%);
  box-shadow: 0 0 0 3px rgba(233, 75, 108, 0.08);
}
.topup-card-option.disabled { opacity: 0.5; cursor: not-allowed; }
.topup-card-option input[type="radio"] {
  width: 18px; height: 18px; accent-color: #E94B6C; cursor: pointer;
  margin: 0;
}
.topup-card-brand {
  width: 44px; height: 30px;
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 800; letter-spacing: 0.4px;
  background: #1a1d29; color: #fff; border-radius: 6px;
  flex-shrink: 0;
}
.topup-card-brand.new {
  background: #fff; color: #6c757d; border: 1px dashed #d8d9e1;
  font-size: 18px; font-weight: 400;
}
.topup-card-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
.topup-card-title { font-size: 14px; font-weight: 600; color: #1a1d29; }
.topup-card-sub { font-size: 11px; color: #6c757d; }

.topup-success {
  padding: 10px 12px;
  background: #e8f7ef; color: #14764e;
  border-radius: 8px; font-size: 13px;
}

.topup-actions {
  display: flex; gap: 10px; justify-content: flex-end;
  margin-top: 4px;
}
.topup-cancel, .topup-pay {
  padding: 11px 22px;
  border-radius: 10px;
  font-size: 14px; font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.15s;
}
.topup-cancel {
  background: #fff; color: #6c757d; border: 1px solid #ECEDF2;
}
.topup-cancel:hover { background: #F7F8FB; }
.topup-pay {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);
  color: #fff;
}
.topup-pay:hover:not(:disabled) { filter: brightness(1.05); box-shadow: 0 4px 14px rgba(233, 75, 108, 0.3); }
.topup-pay:disabled { opacity: 0.6; cursor: wait; }

.topup-error {
  padding: 10px 12px;
  background: #fee;
  color: #c00;
  border-radius: 8px;
  font-size: 13px;
}

.topup-hint {
  margin: 0;
  font-size: 12px;
  color: #adb5bd;
  text-align: center;
  font-style: italic;
}

/* ─── Payment Methods List ─────────────────────────────────── */

.payment-methods { padding: 8px 0; }
.payment-methods-header {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 16px;
}
.payment-methods-header h3 { margin: 0; font-size: 16px; font-weight: 700; }

.payment-methods-list {
  list-style: none; padding: 0; margin: 0;
  display: flex; flex-direction: column; gap: 10px;
}
.payment-method-row {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 16px;
  border: 1px solid #ECEDF2;
  border-radius: 12px;
  background: #fff;
  transition: border-color 0.15s;
}
.payment-method-row:hover { border-color: #d0d3dc; }
.payment-method-row.default {
  border-color: #E94B6C;
  background: linear-gradient(135deg, rgba(255,107,74,0.03) 0%, rgba(142,58,154,0.03) 100%);
}

.pm-icon {
  width: 50px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  background: #1a1a1a; color: #fff;
  border-radius: 6px;
  font-size: 11px; font-weight: 700; letter-spacing: 0.5px;
  flex-shrink: 0;
}
.pm-label { flex: 1 1; }
.pm-title { font-size: 14px; font-weight: 600; color: #1a1a1a; }
.pm-badge {
  display: inline-block;
  margin-top: 4px;
  font-size: 10px; font-weight: 700; letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 20px;
  background: rgba(233, 75, 108, 0.1);
  color: #E94B6C;
  text-transform: uppercase;
}
.pm-badge.expired {
  background: rgba(231, 76, 60, 0.12);
  color: #c0392b;
}
.pm-badge.sandbox {
  background: rgba(240, 180, 0, 0.15);
  color: #8a6700;
  text-transform: none;
  letter-spacing: 0.2px;
}
.pm-badge.mismatch {
  background: rgba(231, 76, 60, 0.12);
  color: #c0392b;
  text-transform: none;
  letter-spacing: 0.2px;
}
.pm-badge.profile {
  background: rgba(108, 117, 125, 0.12);
  color: #475569;
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 600;
}
.pm-meta-row { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.pm-meta-row .pm-badge { margin-top: 0; }
.payment-method-row.mismatch {
  opacity: 0.7;
  background: #fff8f8;
}
.payment-method-row.mismatch .pm-title { color: #6c757d; }
.payment-method-row.expired {
  opacity: 0.7;
  background: #fff8f8;
  border-color: #f5c6c6;
}
.payment-method-row.expired .pm-title {
  text-decoration: line-through;
  color: var(--text-secondary);
}
.pm-actions { display: flex; gap: 6px; align-items: center; }

.btn-link {
  background: transparent; border: none;
  color: #6c757d;
  font-size: 13px; font-weight: 500;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
}
.btn-link:hover { background: #F7F8FB; color: #1a1a1a; }
.btn-link.danger { color: #c00; }
.btn-link.danger:hover { background: #fee; }
.btn-link:disabled { opacity: 0.5; cursor: wait; }

.btn-primary {
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);
  color: #fff;
  border: none;
  padding: 9px 18px;
  border-radius: 10px;
  font-size: 13px; font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-primary:hover:not(:disabled) { filter: brightness(1.05); box-shadow: 0 3px 10px rgba(233, 75, 108, 0.25); }
.btn-primary:disabled { opacity: 0.6; cursor: wait; }

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  border: 1px dashed #ECEDF2;
  border-radius: 12px;
}

/* Add-Topup dialog client picker */
.add-topup-selected {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 14px;
  border: 1px solid #ECEDF2;
  border-radius: 10px;
  background: #F7F8FB;
  font-size: 14px;
}
.add-topup-selected .muted { color: #6c757d; font-weight: 400; }

.add-topup-suggestions {
  margin-top: 4px;
  border: 1px solid #ECEDF2;
  border-radius: 10px;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
}
.add-topup-suggestion {
  display: flex; justify-content: space-between; align-items: center;
  width: 100%;
  padding: 10px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  border-bottom: 1px solid #F7F8FB;
}
.add-topup-suggestion:last-child { border-bottom: none; }
.add-topup-suggestion:hover { background: rgba(255, 107, 74, 0.05); }
.add-topup-suggestion .muted { color: #6c757d; font-size: 12px; }
.empty-state .muted { color: #adb5bd; font-size: 13px; margin-top: 6px; }

/* ─── Auto-topup Settings ──────────────────────────────────── */

.auto-topup-settings { padding: 8px 0; max-width: 560px; }

.auto-topup-empty {
  padding: 36px 24px;
  border: 1px dashed #d8d9e1;
  border-radius: 14px;
  text-align: center;
  background: #fafbfc;
}
.auto-topup-empty-icon { font-size: 32px; margin-bottom: 10px; }
.auto-topup-empty-title { font-size: 15px; font-weight: 700; color: #1a1d29; margin-bottom: 6px; }
.auto-topup-empty-sub { font-size: 13px; color: #6c757d; line-height: 1.5; max-width: 380px; margin: 0 auto; }
.auto-topup-header { margin-bottom: 20px; }
.auto-topup-header h3 { margin: 0 0 6px 0; font-size: 18px; font-weight: 700; }
.auto-topup-header .muted { color: #6c757d; font-size: 13px; margin: 0; line-height: 1.5; }

/* Toggle row — large clickable card with switch */
.auto-topup-toggle {
  display: flex; align-items: center; justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border: 1px solid #ECEDF2;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  margin-bottom: 18px;
}
.auto-topup-toggle:hover { border-color: #d8d9e1; }
.auto-topup-toggle.on {
  border-color: rgba(233, 75, 108, 0.35);
  background: linear-gradient(180deg, #fff 0%, #fff7f5 100%);
}
.auto-topup-toggle.disabled { cursor: not-allowed; opacity: 0.6; }
.auto-topup-toggle-text { display: flex; flex-direction: column; gap: 2px; }
.auto-topup-toggle-title { font-size: 15px; font-weight: 700; color: #1a1d29; }
.auto-topup-toggle-sub { font-size: 12px; color: #6c757d; }

.switch {
  position: relative;
  width: 44px; height: 26px;
  background: #d8d9e1;
  border-radius: 999px;
  flex-shrink: 0;
  transition: background 0.18s;
}
.switch-knob {
  position: absolute; top: 3px; left: 3px;
  width: 20px; height: 20px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.18s;
}
.auto-topup-toggle.on .switch {
  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);
}
.auto-topup-toggle.on .switch-knob { transform: translateX(18px); }

.auto-topup-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 6px;
}
.auto-topup-field { display: flex; flex-direction: column; gap: 6px; }
.auto-topup-field > label {
  font-size: 12px; font-weight: 600; color: #6c757d;
  text-transform: uppercase; letter-spacing: 0.4px;
}

.input-with-suffix {
  position: relative;
  display: flex; align-items: center;
}
.input-with-suffix input {
  flex: 1 1;
  padding: 10px 50px 10px 14px;
  border: 1px solid #ECEDF2;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
}
.input-with-suffix input:focus { border-color: #E94B6C; }
.input-with-suffix input:disabled { background: #f5f5f5; color: #adb5bd; cursor: not-allowed; }
.input-with-suffix .suffix {
  position: absolute; right: 14px;
  font-size: 13px; font-weight: 600; color: #6c757d;
  pointer-events: none;
}

.form-actions { margin-top: 18px; }

.alert-error {
  padding: 10px 12px;
  background: #fee;
  color: #c00;
  border-radius: 8px;
  font-size: 13px;
  margin: 12px 0;
}
.alert-warn {
  padding: 12px 14px;
  background: #fff8e6;
  color: #8a6700;
  border-radius: 8px;
  font-size: 13px;
  margin: 12px 0;
  border-left: 3px solid #f0b400;
}

.loading {
  padding: 24px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/payments.css"],"names":[],"mappings":"AAAA;;6CAE6C;;AAE7C,iEAAiE;;AAEjE;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;AACA,sBAAsB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE9D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,yDAAyD;AAC3D;AACA;EACE,OAAO,wCAAwC,EAAE,UAAU,EAAE;EAC7D,OAAO,iCAAiC,EAAE,UAAU,EAAE;AACxD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yFAAyF;AAC3F;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACjE;EACE,YAAY,EAAE,uBAAuB,EAAE,eAAe;EACtD,eAAe,EAAE,cAAc,EAAE,cAAc,EAAE,cAAc;EAC/D,kBAAkB;AACpB;AACA,qBAAqB,4BAA4B,EAAE,cAAc,EAAE;;AAEnE,cAAc,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE/E;EACE,aAAa,EAAE,MAAM;EACrB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B;EAC/D,eAAe;EACf,oCAAoC;EACpC,qBAAqB;AACvB;AACA,0BAA0B,0BAA0B,EAAE;AACtD;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yFAAyF;EACzF,yCAAyC;AAC3C;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,4BAA4B;EAC/D,yBAAyB,EAAE,qBAAqB;AAClD;AACA;EACE,eAAe,EAAE,0BAA0B;EAC3C,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,qBAAqB;AACvB;AACA;EACE,uDAAuD;EACvD,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B;EAC/D,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA,0BAA0B,mBAAmB,EAAE,0BAA0B,EAAE;AAC3E,2BAA2B,mBAAmB,EAAE;;AAEhD,iBAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C;EACE,SAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA,sBAAsB,qBAAqB,EAAE,cAAc,EAAE;AAC7D;EACE,0EAA0E;EAC1E,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;EAC/C,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACnD;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA,kCAAkC,qBAAqB,EAAE;;AAEzD;uCACuC;AACvC;EACE,kBAAkB;EAClB,+FAA+F;EAC/F,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa,EAAE,sBAAsB,EAAE,QAAQ;AACjD;AACA,4BAA4B,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACjF;EACE,mBAAmB,EAAE,qBAAqB,EAAE,cAAc;EAC1D,eAAe;AACjB;AACA;EACE,aAAa,EAAE,qBAAqB,EAAE,QAAQ;EAC9C,eAAe;AACjB;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,cAAc;AAChB;AACA;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,kCAAkC;AACpC;AACA;EACE,eAAe,EAAE,cAAc;AACjC;AACA;EACE,eAAe,EAAE,cAAc;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,eAAe,EAAE,eAAe;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,2BAA2B,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;;AAEvE,mEAAmE;AACnE,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;AACpB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kEAAkE;AACpE;AACA,0CAA0C,qBAAqB,EAAE;AACjE;EACE,sCAAsC;EACtC,0DAA0D;EAC1D,8CAA8C;AAChD;AACA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE;EACE,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE,eAAe;EACjE,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,mBAAmB,EAAE,WAAW,EAAE,kBAAkB;EACpD,cAAc;AAChB;AACA;EACE,gBAAgB,EAAE,cAAc,EAAE,0BAA0B;EAC5D,eAAe,EAAE,gBAAgB;AACnC;AACA,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE;AAClF,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACvE,kBAAkB,eAAe,EAAE,cAAc,EAAE;;AAEnD;EACE,kBAAkB;EAClB,mBAAmB,EAAE,cAAc;EACnC,kBAAkB,EAAE,eAAe;AACrC;;AAEA;EACE,aAAa,EAAE,SAAS,EAAE,yBAAyB;EACnD,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAE,gBAAgB;EACjC,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB;AAC7D;AACA,sBAAsB,mBAAmB,EAAE;AAC3C;EACE,0EAA0E;EAC1E,WAAW;AACb;AACA,kCAAkC,wBAAwB,EAAE,8CAA8C,EAAE;AAC5G,sBAAsB,YAAY,EAAE,YAAY,EAAE;;AAElD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iEAAiE;;AAEjE,mBAAmB,cAAc,EAAE;AACnC;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,mBAAmB;AACrB;AACA,6BAA6B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE3E;EACE,gBAAgB,EAAE,UAAU,EAAE,SAAS;EACvC,aAAa,EAAE,sBAAsB,EAAE,SAAS;AAClD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;AACA,4BAA4B,qBAAqB,EAAE;AACnD;EACE,qBAAqB;EACrB,yFAAyF;AAC3F;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mBAAmB,EAAE,WAAW;EAChC,kBAAkB;EAClB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,cAAc;AAChB;AACA,YAAY,SAAO,EAAE;AACrB,YAAY,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC/D;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;AACA,eAAe,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;AAC1E,yBAAyB,aAAa,EAAE;AACxC;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA,yCAAyC,cAAc,EAAE;AACzD;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,cAAc,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;;AAE5D;EACE,uBAAuB,EAAE,YAAY;EACrC,cAAc;EACd,eAAe,EAAE,gBAAgB;EACjC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,WAAW,EAAE;AAChC,yBAAyB,gBAAgB,EAAE;AAC3C,qBAAqB,YAAY,EAAE,YAAY,EAAE;;AAEjD;EACE,0EAA0E;EAC1E,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAE,gBAAgB;EACjC,eAAe;EACf,qBAAqB;AACvB;AACA,oCAAoC,wBAAwB,EAAE,+CAA+C,EAAE;AAC/G,wBAAwB,YAAY,EAAE,YAAY,EAAE;;AAEpD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA,6BAA6B,cAAc,EAAE,gBAAgB,EAAE;;AAE/D;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB;EAClE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;AACA,mCAAmC,mBAAmB,EAAE;AACxD,8BAA8B,oCAAoC,EAAE;AACpE,+BAA+B,cAAc,EAAE,eAAe,EAAE;AAChE,sBAAsB,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE;;AAExE,iEAAiE;;AAEjE,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;;AAEzD;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,yBAAyB,eAAe,EAAE,mBAAmB,EAAE;AAC/D,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACjG,wBAAwB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7G,qBAAqB,mBAAmB,EAAE;AAC1C,wBAAwB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9E,4BAA4B,cAAc,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAE1F,kDAAkD;AAClD;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kEAAkE;EAClE,mBAAmB;AACrB;AACA,2BAA2B,qBAAqB,EAAE;AAClD;EACE,sCAAsC;EACtC,0DAA0D;AAC5D;AACA,8BAA8B,mBAAmB,EAAE,YAAY,EAAE;AACjE,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9E,yBAAyB,eAAe,EAAE,cAAc,EAAE;;AAE1D;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,kBAAkB,EAAE,QAAQ,EAAE,SAAS;EACvC,WAAW,EAAE,YAAY;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;AACA;EACE,8DAA8D;AAChE;AACA,qCAAqC,2BAA2B,EAAE;;AAElE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,mBAAmB;AACpC;AACA;EACE,SAAO;EACP,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;AACA,iCAAiC,qBAAqB,EAAE;AACxD,oCAAoC,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9F;EACE,kBAAkB,EAAE,WAAW;EAC/B,eAAe,EAAE,gBAAgB,EAAE,cAAc;EACjD,oBAAoB;AACtB;;AAEA,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* Payment methods + auto-topup + top-up dialog\n   Imported by BillingPage. Brand-cohesive with the rest of the app\n   (gradient: #FF6B4A → #E94B6C → #8E3A9A). */\n\n/* ─── TopUp Dialog ─────────────────────────────────────────── */\n\n.topup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 15, 20, 0.55);\n  backdrop-filter: blur(4px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: tuFadeIn 180ms ease;\n}\n@keyframes tuFadeIn { from { opacity: 0; } to { opacity: 1; } }\n\n.topup-dialog {\n  background: #fff;\n  border-radius: 16px;\n  width: min(440px, 92vw);\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  animation: tuSlideIn 240ms cubic-bezier(0.2, 0.7, 0.2, 1);\n}\n@keyframes tuSlideIn {\n  from { transform: translateY(12px) scale(0.985); opacity: 0; }\n  to   { transform: translateY(0) scale(1); opacity: 1; }\n}\n\n.topup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 22px;\n  border-bottom: 1px solid #ECEDF2;\n  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);\n}\n.topup-header h3 { margin: 0; font-size: 18px; font-weight: 700; }\n.topup-close {\n  border: none; background: transparent; cursor: pointer;\n  font-size: 24px; line-height: 1; color: #6c757d; padding: 0 6px;\n  border-radius: 6px;\n}\n.topup-close:hover { background: rgba(0,0,0,0.05); color: #1a1a1a; }\n\n.topup-body { padding: 22px; display: flex; flex-direction: column; gap: 16px; }\n\n.topup-method-tabs {\n  display: flex; gap: 0;\n  border-bottom: 1px solid #ECEDF2;\n  padding: 0 22px;\n}\n.topup-method-tab {\n  flex: 1;\n  background: transparent;\n  border: none;\n  padding: 12px 16px;\n  font-size: 14px; font-weight: 600; color: var(--text-secondary);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.15s;\n}\n.topup-method-tab:hover { color: var(--text-primary); }\n.topup-method-tab.active {\n  color: #E94B6C;\n  border-bottom-color: #E94B6C;\n}\n\n.bank-detail {\n  display: flex; flex-direction: column; gap: 4px;\n  padding: 10px 14px;\n  background: #F7F8FB;\n  border-radius: 10px;\n}\n.bank-detail-highlight {\n  background: linear-gradient(135deg, rgba(255,107,74,0.06) 0%, rgba(142,58,154,0.06) 100%);\n  border: 1px solid rgba(233, 75, 108, 0.3);\n}\n.bank-detail-label {\n  font-size: 11px; font-weight: 600; color: var(--text-secondary);\n  text-transform: uppercase; letter-spacing: 0.4px;\n}\n.bank-detail-value {\n  font-size: 14px; color: var(--text-primary);\n  display: flex; align-items: center; gap: 8px;\n  word-break: break-all;\n}\n.bank-detail-value.mono {\n  font-family: 'JetBrains Mono', 'Courier New', monospace;\n  font-size: 13px;\n}\n.bank-detail-copy {\n  background: #fff;\n  border: 1px solid #ECEDF2;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px; font-weight: 600; color: var(--text-secondary);\n  cursor: pointer;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n.bank-detail-copy:hover { background: #F7F8FB; color: var(--text-primary); }\n.bank-detail-copy:active { background: #ECEDF2; }\n\n.topup-presets { display: flex; gap: 8px; }\n.topup-preset {\n  flex: 1 1 0;\n  min-width: 0;\n  white-space: nowrap;\n  border: 1px solid #ECEDF2;\n  background: #fff;\n  border-radius: 10px;\n  padding: 10px 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  color: #6c757d;\n  transition: all 0.15s;\n}\n.topup-preset:hover { border-color: #E94B6C; color: #1a1a1a; }\n.topup-preset.active {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);\n  color: #fff;\n  border-color: transparent;\n}\n\n.topup-amount-label {\n  display: flex; flex-direction: column; gap: 6px;\n  font-size: 13px; font-weight: 600; color: #6c757d;\n}\n.topup-amount-label input {\n  padding: 12px 14px;\n  border: 1px solid #ECEDF2;\n  border-radius: 10px;\n  font-size: 18px;\n  font-weight: 600;\n  font-family: inherit;\n  outline: none;\n}\n.topup-amount-label input:focus { border-color: #E94B6C; }\n\n/* FX preview shown under the amount field when the card charge currency\n   differs from the balance currency. */\n.topup-fx-preview {\n  padding: 10px 12px;\n  background: linear-gradient(180deg, rgba(233, 75, 108, 0.06) 0%, rgba(142, 58, 154, 0.04) 100%);\n  border: 1px solid rgba(233, 75, 108, 0.18);\n  border-radius: 10px;\n  display: flex; flex-direction: column; gap: 4px;\n}\n.topup-fx-preview.loading { color: #6c757d; font-size: 12px; font-style: italic; }\n.topup-fx-preview.error {\n  background: #fde8e8; border-color: #f5cdd2; color: #c1392b;\n  font-size: 12px;\n}\n.topup-fx-row {\n  display: flex; align-items: baseline; gap: 8px;\n  flex-wrap: wrap;\n}\n.topup-fx-arrow {\n  font-size: 16px; font-weight: 700;\n  color: #E94B6C;\n}\n.topup-fx-amount {\n  font-size: 17px; font-weight: 700; color: #1a1d29;\n  font-variant-numeric: tabular-nums;\n}\n.topup-fx-meta {\n  font-size: 12px; color: #6c757d;\n}\n.topup-fx-rate {\n  font-size: 11px; color: #6c757d;\n  font-variant-numeric: tabular-nums;\n}\n\n.topup-save-toggle {\n  display: flex; align-items: center; gap: 10px;\n  font-size: 14px; cursor: pointer;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #F7F8FB;\n}\n.topup-save-toggle input { width: 18px; height: 18px; cursor: pointer; }\n\n/* ─── Saved-card picker inside Top up dialog ─────────────────── */\n.topup-cards { display: flex; flex-direction: column; gap: 8px; }\n.topup-cards-label {\n  font-size: 12px; font-weight: 600; color: #6c757d;\n  text-transform: uppercase; letter-spacing: 0.4px;\n  margin-bottom: 2px;\n}\n.topup-card-option {\n  display: flex; align-items: center; gap: 12px;\n  padding: 11px 14px;\n  border: 1px solid #ECEDF2;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n}\n.topup-card-option:hover:not(.disabled) { border-color: #d8d9e1; }\n.topup-card-option.selected {\n  border-color: rgba(233, 75, 108, 0.55);\n  background: linear-gradient(180deg, #fff 0%, #fff7f5 100%);\n  box-shadow: 0 0 0 3px rgba(233, 75, 108, 0.08);\n}\n.topup-card-option.disabled { opacity: 0.5; cursor: not-allowed; }\n.topup-card-option input[type=\"radio\"] {\n  width: 18px; height: 18px; accent-color: #E94B6C; cursor: pointer;\n  margin: 0;\n}\n.topup-card-brand {\n  width: 44px; height: 30px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 10px; font-weight: 800; letter-spacing: 0.4px;\n  background: #1a1d29; color: #fff; border-radius: 6px;\n  flex-shrink: 0;\n}\n.topup-card-brand.new {\n  background: #fff; color: #6c757d; border: 1px dashed #d8d9e1;\n  font-size: 18px; font-weight: 400;\n}\n.topup-card-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }\n.topup-card-title { font-size: 14px; font-weight: 600; color: #1a1d29; }\n.topup-card-sub { font-size: 11px; color: #6c757d; }\n\n.topup-success {\n  padding: 10px 12px;\n  background: #e8f7ef; color: #14764e;\n  border-radius: 8px; font-size: 13px;\n}\n\n.topup-actions {\n  display: flex; gap: 10px; justify-content: flex-end;\n  margin-top: 4px;\n}\n.topup-cancel, .topup-pay {\n  padding: 11px 22px;\n  border-radius: 10px;\n  font-size: 14px; font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.15s;\n}\n.topup-cancel {\n  background: #fff; color: #6c757d; border: 1px solid #ECEDF2;\n}\n.topup-cancel:hover { background: #F7F8FB; }\n.topup-pay {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);\n  color: #fff;\n}\n.topup-pay:hover:not(:disabled) { filter: brightness(1.05); box-shadow: 0 4px 14px rgba(233, 75, 108, 0.3); }\n.topup-pay:disabled { opacity: 0.6; cursor: wait; }\n\n.topup-error {\n  padding: 10px 12px;\n  background: #fee;\n  color: #c00;\n  border-radius: 8px;\n  font-size: 13px;\n}\n\n.topup-hint {\n  margin: 0;\n  font-size: 12px;\n  color: #adb5bd;\n  text-align: center;\n  font-style: italic;\n}\n\n/* ─── Payment Methods List ─────────────────────────────────── */\n\n.payment-methods { padding: 8px 0; }\n.payment-methods-header {\n  display: flex; justify-content: space-between; align-items: center;\n  margin-bottom: 16px;\n}\n.payment-methods-header h3 { margin: 0; font-size: 16px; font-weight: 700; }\n\n.payment-methods-list {\n  list-style: none; padding: 0; margin: 0;\n  display: flex; flex-direction: column; gap: 10px;\n}\n.payment-method-row {\n  display: flex; align-items: center; gap: 14px;\n  padding: 14px 16px;\n  border: 1px solid #ECEDF2;\n  border-radius: 12px;\n  background: #fff;\n  transition: border-color 0.15s;\n}\n.payment-method-row:hover { border-color: #d0d3dc; }\n.payment-method-row.default {\n  border-color: #E94B6C;\n  background: linear-gradient(135deg, rgba(255,107,74,0.03) 0%, rgba(142,58,154,0.03) 100%);\n}\n\n.pm-icon {\n  width: 50px; height: 32px;\n  display: flex; align-items: center; justify-content: center;\n  background: #1a1a1a; color: #fff;\n  border-radius: 6px;\n  font-size: 11px; font-weight: 700; letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n.pm-label { flex: 1; }\n.pm-title { font-size: 14px; font-weight: 600; color: #1a1a1a; }\n.pm-badge {\n  display: inline-block;\n  margin-top: 4px;\n  font-size: 10px; font-weight: 700; letter-spacing: 0.5px;\n  padding: 2px 8px;\n  border-radius: 20px;\n  background: rgba(233, 75, 108, 0.1);\n  color: #E94B6C;\n  text-transform: uppercase;\n}\n.pm-badge.expired {\n  background: rgba(231, 76, 60, 0.12);\n  color: #c0392b;\n}\n.pm-badge.sandbox {\n  background: rgba(240, 180, 0, 0.15);\n  color: #8a6700;\n  text-transform: none;\n  letter-spacing: 0.2px;\n}\n.pm-badge.mismatch {\n  background: rgba(231, 76, 60, 0.12);\n  color: #c0392b;\n  text-transform: none;\n  letter-spacing: 0.2px;\n}\n.pm-badge.profile {\n  background: rgba(108, 117, 125, 0.12);\n  color: #475569;\n  text-transform: none;\n  letter-spacing: 0.2px;\n  font-weight: 600;\n}\n.pm-meta-row { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }\n.pm-meta-row .pm-badge { margin-top: 0; }\n.payment-method-row.mismatch {\n  opacity: 0.7;\n  background: #fff8f8;\n}\n.payment-method-row.mismatch .pm-title { color: #6c757d; }\n.payment-method-row.expired {\n  opacity: 0.7;\n  background: #fff8f8;\n  border-color: #f5c6c6;\n}\n.payment-method-row.expired .pm-title {\n  text-decoration: line-through;\n  color: var(--text-secondary);\n}\n.pm-actions { display: flex; gap: 6px; align-items: center; }\n\n.btn-link {\n  background: transparent; border: none;\n  color: #6c757d;\n  font-size: 13px; font-weight: 500;\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n.btn-link:hover { background: #F7F8FB; color: #1a1a1a; }\n.btn-link.danger { color: #c00; }\n.btn-link.danger:hover { background: #fee; }\n.btn-link:disabled { opacity: 0.5; cursor: wait; }\n\n.btn-primary {\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 60%, #8E3A9A 100%);\n  color: #fff;\n  border: none;\n  padding: 9px 18px;\n  border-radius: 10px;\n  font-size: 13px; font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.btn-primary:hover:not(:disabled) { filter: brightness(1.05); box-shadow: 0 3px 10px rgba(233, 75, 108, 0.25); }\n.btn-primary:disabled { opacity: 0.6; cursor: wait; }\n\n.empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n  border: 1px dashed #ECEDF2;\n  border-radius: 12px;\n}\n\n/* Add-Topup dialog client picker */\n.add-topup-selected {\n  display: flex; align-items: center; gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid #ECEDF2;\n  border-radius: 10px;\n  background: #F7F8FB;\n  font-size: 14px;\n}\n.add-topup-selected .muted { color: #6c757d; font-weight: 400; }\n\n.add-topup-suggestions {\n  margin-top: 4px;\n  border: 1px solid #ECEDF2;\n  border-radius: 10px;\n  max-height: 240px;\n  overflow-y: auto;\n  background: #fff;\n}\n.add-topup-suggestion {\n  display: flex; justify-content: space-between; align-items: center;\n  width: 100%;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: left;\n  border-bottom: 1px solid #F7F8FB;\n}\n.add-topup-suggestion:last-child { border-bottom: none; }\n.add-topup-suggestion:hover { background: rgba(255, 107, 74, 0.05); }\n.add-topup-suggestion .muted { color: #6c757d; font-size: 12px; }\n.empty-state .muted { color: #adb5bd; font-size: 13px; margin-top: 6px; }\n\n/* ─── Auto-topup Settings ──────────────────────────────────── */\n\n.auto-topup-settings { padding: 8px 0; max-width: 560px; }\n\n.auto-topup-empty {\n  padding: 36px 24px;\n  border: 1px dashed #d8d9e1;\n  border-radius: 14px;\n  text-align: center;\n  background: #fafbfc;\n}\n.auto-topup-empty-icon { font-size: 32px; margin-bottom: 10px; }\n.auto-topup-empty-title { font-size: 15px; font-weight: 700; color: #1a1d29; margin-bottom: 6px; }\n.auto-topup-empty-sub { font-size: 13px; color: #6c757d; line-height: 1.5; max-width: 380px; margin: 0 auto; }\n.auto-topup-header { margin-bottom: 20px; }\n.auto-topup-header h3 { margin: 0 0 6px 0; font-size: 18px; font-weight: 700; }\n.auto-topup-header .muted { color: #6c757d; font-size: 13px; margin: 0; line-height: 1.5; }\n\n/* Toggle row — large clickable card with switch */\n.auto-topup-toggle {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 16px;\n  padding: 16px 18px;\n  border: 1px solid #ECEDF2;\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;\n  margin-bottom: 18px;\n}\n.auto-topup-toggle:hover { border-color: #d8d9e1; }\n.auto-topup-toggle.on {\n  border-color: rgba(233, 75, 108, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #fff7f5 100%);\n}\n.auto-topup-toggle.disabled { cursor: not-allowed; opacity: 0.6; }\n.auto-topup-toggle-text { display: flex; flex-direction: column; gap: 2px; }\n.auto-topup-toggle-title { font-size: 15px; font-weight: 700; color: #1a1d29; }\n.auto-topup-toggle-sub { font-size: 12px; color: #6c757d; }\n\n.switch {\n  position: relative;\n  width: 44px; height: 26px;\n  background: #d8d9e1;\n  border-radius: 999px;\n  flex-shrink: 0;\n  transition: background 0.18s;\n}\n.switch-knob {\n  position: absolute; top: 3px; left: 3px;\n  width: 20px; height: 20px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: transform 0.18s;\n}\n.auto-topup-toggle.on .switch {\n  background: linear-gradient(135deg, #FF6B4A, #E94B6C, #8E3A9A);\n}\n.auto-topup-toggle.on .switch-knob { transform: translateX(18px); }\n\n.auto-topup-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 6px;\n}\n.auto-topup-field { display: flex; flex-direction: column; gap: 6px; }\n.auto-topup-field > label {\n  font-size: 12px; font-weight: 600; color: #6c757d;\n  text-transform: uppercase; letter-spacing: 0.4px;\n}\n\n.input-with-suffix {\n  position: relative;\n  display: flex; align-items: center;\n}\n.input-with-suffix input {\n  flex: 1;\n  padding: 10px 50px 10px 14px;\n  border: 1px solid #ECEDF2;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n}\n.input-with-suffix input:focus { border-color: #E94B6C; }\n.input-with-suffix input:disabled { background: #f5f5f5; color: #adb5bd; cursor: not-allowed; }\n.input-with-suffix .suffix {\n  position: absolute; right: 14px;\n  font-size: 13px; font-weight: 600; color: #6c757d;\n  pointer-events: none;\n}\n\n.form-actions { margin-top: 18px; }\n\n.alert-error {\n  padding: 10px 12px;\n  background: #fee;\n  color: #c00;\n  border-radius: 8px;\n  font-size: 13px;\n  margin: 12px 0;\n}\n.alert-warn {\n  padding: 12px 14px;\n  background: #fff8e6;\n  color: #8a6700;\n  border-radius: 8px;\n  font-size: 13px;\n  margin: 12px 0;\n  border-left: 3px solid #f0b400;\n}\n\n.loading {\n  padding: 24px;\n  text-align: center;\n  color: #6c757d;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
